import React from 'react';

import { Inject } from '@odinjs/odin';

import { DeckAPI, FetchAPI, FormAPI, InputAPI } from '@philips-emr/tws-components';
import { Key } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnAfterFetch, OnCancel, OnKeyPress, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, KeyboardEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { generateUUID } from '@philips-emr/tws-utils';

import { ReactComponent as MagnifierIcon } from '../../../resources/assets/search.svg';
import { ProductsByUserAliases as Aliases, FragmentNames } from '../../codegen';
import './products-by-user.scss';
import NoLoginBaseController from '../no-login-base-controller';

interface ProductByUser extends Record<string, Value> {
  dsPlan: string;
  cdAns: string;
  dsContractingType: string;
  dsCoverage: string;
  dsSegmentation: string;
  dsSituation: string;
  group: string;
}

@Controller({ fragment: FragmentNames.PRODUCTS_BY_USER })
export default class ProductByUserController extends NoLoginBaseController {

  @Inject(Aliases.DECK)
  private deck: DeckAPI;

  @Inject(Aliases.FETCH_DECK)
  private fetch: FetchAPI;

  @Inject(Aliases.FORM_FILTER)
  private form: FormAPI;

  private user: string;

  @OnMount(Aliases.ROOT_COMPONENT)
  onRootMount(): void {
    this.noLoginThemeSetUp();
  }

  @OnMount(Aliases.INPUT_FILTER)
  onMountFilter(event: MountEvent): void {
    const api = event.target as InputAPI;
    this.form.setRecord({ ...this.form.getRecord() });
    api.setExternalAction(<MagnifierIcon className="c-module-selector__search-icon custom-svg-search-pointer-cursor" onClick={() => this.onFormSubmit()} />);
  }

  @OnKeyPress(Aliases.INPUT_FILTER)
  onInputKeyPress(event: KeyboardEvent): void {
    if (event.key === Key.ENTER) {
      this.onFormSubmit();
    }
  }

  @OnSubmit(Aliases.FORM_FILTER)
  onFormSubmit(): void {
    const { filter } = this.form.getRecord();
    const params = this.fetch.getParameters();

    this.fetch.setParameters({ ...params, filter: filter || '' });
    this.fetch.forceFetch();
  }

  @OnCancel(Aliases.FORM_FILTER)
  onFormCancel(): void {
    const params = this.fetch.getParameters();
    const filter = '';

    this.form.setRecord({ filter });
    this.fetch.setParameters({ ...params, filter });
    this.fetch.forceFetch();
  }

  @OnMount(Aliases.FETCH_DECK)
  onMountFetch(): void {
    this.user = `AnonPLS-${generateUUID()}`.substring(0, 15);
    this.fetch.setParameters({ user: this.user });
    this.deck.setLoading(true);
  }

  @OnAfterFetch(Aliases.FETCH_DECK)
  onAfterFetch(event: FetchEvent): void {
    let list = event.data as ProductByUser[];
    if (list) {
      list = list.map(value => {
        value.group = 'group1';
        return value;
      });
      this.deck.setData(list);
    }
    this.deck.setLoading(false);
  }
}
